import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { getAllowedAttributes } from '../../props-filters';

import './AdditionalNav.scss';

var AdditionalNav = function AdditionalNav(_ref) {
  var children = _ref.children,
      slot = _ref.slot,
      restProps = _objectWithoutProperties(_ref, ['children', 'slot']);

  return React.createElement(
    'nav',
    _extends({ className: 'sb-header-additional-nav' }, getAllowedAttributes(restProps)),
    React.createElement(
      'div',
      { className: 'sb-header-additional-nav__list' },
      children
    )
  );
};

AdditionalNav.propTypes = {
  slot: PropTypes.oneOf(['sub-nav-end']),
  children: PropTypes.node
};

export default AdditionalNav;
//# sourceMappingURL=AdditionalNav.js.map